import { current } from './current';
import { reset } from './reset';
import { save } from './save';

export const ThemeService = {
  current,
  reset,
  save,
};
